import { yup } from '@framework/validation/initYup.ts';
import { isEmpty, omitBy } from 'lodash';
import { type ObjectSchema } from 'yup';
import { mergeList } from '../../../validator/utils/mergeList.ts';
import { type IRule, type RuleType } from '../IRule.ts';
import { getAllRuleTypes, type IRulesConfig } from './getAllRuleTypes.ts';

/**
 * Validatore per il campo delle regole di un widget.
 * Costruisce un validatore per ogni regola presente nel sistema.
 */
export const RulesSchema: yup.Lazy<IRulesConfig> = yup.lazy(
  (value: IRulesConfig): yup.ObjectSchema<IRulesConfig> => {
    const clean = omitBy(value, isEmpty);
    return yup
      .object()
      .shape(buildRulesSchemaShape(clean))
      .optional()
      .default({}) as unknown as yup.ObjectSchema<IRulesConfig>;
  },
);

/** Ritorna la shape di validazione di ogni tipo di regola presente */
function buildRulesSchemaShape(
  value: IRulesConfig,
): Record<RuleType, ObjectSchema<IRule>> {
  const rules = getAllRuleTypes().filter(rule => value[rule.type]);
  const ruleSchemaList = rules.map(rule => ({
    [rule.type]: rule.configValidator,
  }));
  return mergeList(ruleSchemaList);
}
